import { z } from 'zod';

export const ResourceFormSchema = z
  .object({
    label: z.string(),
    name: z.string(),
    sortOrder: z.number().nullable(),
    resourcePath: z.string(),
    apiPath: z.string(),
    resourcePlatform: z.object({ id: z.string(), name: z.string() }).nullable(),
    parent: z.object({ id: z.string(), name: z.string() }).nullable(),
    authIdentifier: z.string(),
    isHidden: z.boolean(),
    controller: z.string(),
    availablePermissions: z.array(z.string()),
  })
  .superRefine((data, ctx) => {
    if (!data.label?.trim()) {
      ctx.addIssue({
        path: ['label'],
        message: 'Label is required',
        code: 'custom',
      });
    }

    if (!data.name?.trim()) {
      ctx.addIssue({
        path: ['name'],
        message: 'Name is required',
        code: 'custom',
      });
    }

    if (data.sortOrder === null || data.sortOrder === undefined) {
      ctx.addIssue({
        path: ['sortOrder'],
        message: 'Sort order is required',
        code: 'custom',
      });
    } else if (!Number.isInteger(data.sortOrder)) {
      ctx.addIssue({
        path: ['sortOrder'],
        message: 'Sort order must be a whole number',
        code: 'custom',
      });
    }

    if (!data.resourcePath?.trim()) {
      ctx.addIssue({
        path: ['resourcePath'],
        message: 'Resource path is required',
        code: 'custom',
      });
    }

    if (!data.apiPath?.trim()) {
      ctx.addIssue({
        path: ['apiPath'],
        message: 'API path is required',
        code: 'custom',
      });
    }

    if (!data.resourcePlatform?.id) {
      ctx.addIssue({
        path: ['resourcePlatform'],
        message: 'Platform is required',
        code: 'custom',
      });
    }

    if (!data.authIdentifier?.trim()) {
      ctx.addIssue({
        path: ['authIdentifier'],
        message: 'Auth identifier is required',
        code: 'custom',
      });
    }

    if (data.availablePermissions.length === 0) {
      ctx.addIssue({
        path: ['availablePermissions'],
        message: 'At least one permission is required',
        code: 'custom',
      });
    }
  });
